/*
 * Injects theme CSS overrides into the Shadow DOM of the Bundle Kit Pro app's
 * <bundle-size-selector> (desktop sidebar tier badges). External stylesheets
 * never cross a shadow boundary — open or closed — so bundle-custom.css can't
 * reach `.save-pill` in there; the style has to be planted inside the root.
 *
 * Two paths, so timing/mode of the app's async render doesn't matter:
 *  1. attachShadow is patched so any root the app creates from now on gets the
 *     sheet immediately — this also captures a `closed` root, which is
 *     otherwise unreachable (element.shadowRoot === null).
 *  2. A sweep on DOMContentLoaded covers roots attached before this script ran
 *     (only reachable when `open`).
 *
 * Loaded with defer from theme.liquid BEFORE {{ content_for_header }}, so the
 * patch is in place before the app embed's own deferred scripts execute.
 */
(() => {
  const HOST_TAG = 'BUNDLE-SIZE-SELECTOR';
  const CSS_TEXT =
    '.save-pill { border: none !important; font-size: var(--fluid-14-16, 16px) !important; font-weight: 300 !important; }';
  const injected = new WeakSet();

  const inject = (root) => {
    if (!root || injected.has(root)) return;
    injected.add(root);
    try {
      // Survives the app re-rendering via shadowRoot.innerHTML = …
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(CSS_TEXT);
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    } catch {
      const style = document.createElement('style');
      style.textContent = CSS_TEXT;
      root.appendChild(style);
    }
  };

  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const root = originalAttachShadow.call(this, init);
    if (this.tagName === HOST_TAG) inject(root);
    return root;
  };

  const sweep = () => {
    document
      .querySelectorAll(HOST_TAG.toLowerCase())
      .forEach((el) => inject(el.shadowRoot));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
})();
